import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import Support from "./Support";

function App (){
  return (
    <Router>
      <nav className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-6 flex justify-center">
        <div className="container flex justify-between items-center">
          <h1 className="text-white font-bold text-xl">Wallcrafty</h1>
          <ul className="flex space-x-4">
            <li>
              <Link to="/" className="text-white font-semibold py-2 px-4 rounded-lg transition duration-300 ease-in-out hover:bg-white hover:text-indigo-500">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/support" className="text-white font-semibold py-2 px-4 rounded-lg transition duration-300 ease-in-out hover:bg-white hover:text-indigo-500">
                Support
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </Router>

  )
}

export default App;
